import { createAction } from 'redux-actions';

import { WINDOW_RELOAD } from '../types';

export const windowReload = createAction(WINDOW_RELOAD);


// WEBPACK FOOTER //
// ./src/actions/redirectActions.js